// State keeps bare digits, only the display is grouped; nb-NO uses U+00A0 and "kr" is an adornment

// Digits only, grouped for display. Empty string stays empty; a lone minus survives as itself
export const formatCash = (value) => {
  const raw = String(value ?? '');
  const sign = raw.startsWith('-') ? '-' : '';
  const digits = raw.replace(/\D/g, '');
  return digits === '' ? sign : sign + Number(digits).toLocaleString('nb-NO');
};

// Same grouping for a number that may be negative — avvik is signed
export const formatSignedCash = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '';
  }
  return Number(value).toLocaleString('nb-NO', { maximumFractionDigits: 0 });
};

// onChange body for a grouped cash field; counts digits before the caret so regrouping can't move it
export const readCashInput = (el, { allowNegative = false } = {}) => {
  const raw = el.value;
  const caret = el.selectionStart ?? raw.length;

  // Only a leading minus is a sign; anywhere else it is a stray keystroke
  const sign = allowNegative && raw.trimStart().startsWith('-') ? '-' : '';

  return {
    // Leading zeros stripped: a field starting at 0 would show "01000" after typing 1000
    value: sign + raw.replace(/\D/g, '').replace(/^0+(?=\d)/, ''),
    caretDigits: raw.slice(0, caret).replace(/\D/g, '').length,
  };
};

// Walk regrouped text and find the offset just past `caretDigits` digits
export const caretPositionForDigits = (text, caretDigits) => {
  // Never before the sign, or the next keystroke lands in front of it
  if (caretDigits === 0) return text.startsWith('-') ? 1 : 0;

  let seen = 0;
  for (let i = 0; i < text.length; i++) {
    if (/\d/.test(text[i])) {
      seen += 1;
      if (seen === caretDigits) return i + 1;
    }
  }
  return text.length;
};
